<div class="pointer-events-none z-50 fixed inset-0 flex items-end px-4 py-6 sm:items-start sm:p-6">
  <div class="flex w-full flex-col items-center space-y-4 sm:items-end">
    <div
      *ngFor="let toast of toasts"
      @open
      [class.bg-green-500]="toast.type === StateType.SUCCESS"
      [class.bg-red-500]="toast.type === StateType.DANGER"
      class="pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg shadow-lg">
      <div class="p-4">
        <div class="flex items-start">
          <div class="w-0 flex-1 pt-0.5">
            <p class="text-sm text-white font-medium">
              {{ toast.title | firstCase }}
            </p>
            <p class="mt-1 text-sm text-white">
              {{ toast.message | firstCase }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
